import { FormBase } from 'core/components';

export default class CreateBoxForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'LOOKUP.BOX.NAME',
					rules: 'required|string',
				},
				{
					name: 'height',
					label: 'LOOKUP.BOX.HEIGHT',
					rules: 'required|integer',
				},
				{
					name: 'width',
					label: 'LOOKUP.BOX.WIDTH',
					rules: 'required|integer',
				},
				{
					name: 'length',
					label: 'LOOKUP.BOX.LENGTH',
					rules: 'required|integer',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/CreateBoxForm.js